import { v4 as uuidv4 } from 'uuid';

import { Component, Element, h, Host, Prop, State } from '@stencil/core';

const defaultObserverOptions: IntersectionObserverInit = {
  root: null,
  threshold: 0,
  rootMargin: '0px 0px -150px 0px',
};

const SCROLL_ID = `pn-scroll-wrapper-id-`;

@Component({
  tag: 'pn-scroll',
  styleUrl: 'pn-scroll.scss',
})
export class PnScroll {
  @Element() hostElement: HTMLElement;
  @Prop() observerOptions: IntersectionObserverInit = defaultObserverOptions;
  @Prop() behaviourClasses: string = 'fade slide-up';
  @Prop() transitionDurationSeconds: number = 0.5;
  @Prop() shouldLoop?: boolean = false;
  @Prop() intersectFunc?: Function;
  @Prop() notIntersectFunc?: Function;

  @State() compId: string = null;

  generateUniqueId() {
    return uuidv4();
  }

  handleIntersection(entries: IntersectionObserverEntry[], observer?: IntersectionObserver, onIntersecting?: Function, onNotIntersecting?: Function, shouldLoop?: boolean) {
    entries.forEach(entry => {
      if (!shouldLoop) {
        if (!entry.isIntersecting) {
          onNotIntersecting?.(entry, observer);
          return;
        }
        entry.target.classList.add('in-view');
        onIntersecting?.(entry, observer);
        observer.unobserve(entry.target);
      } else {
        entry.target.classList.toggle('in-view', entry.isIntersecting);
        if (entry.isIntersecting) {
          onIntersecting?.(entry, observer);
        } else {
          onNotIntersecting?.(entry, observer);
        }
      }
    });
  }

  //on load, generate unique id for this wrapper
  componentWillLoad() {
    this.compId = this.generateUniqueId();
  }

  componentDidLoad() {
    const observer = new IntersectionObserver(
      (entries, observer) => this.handleIntersection(entries, observer, this.intersectFunc, this.notIntersectFunc, this.shouldLoop),
      this.observerOptions,
    );
    const objectToObserve = document.getElementById(`${SCROLL_ID}${this.compId}`);
    observer.observe(objectToObserve);
  }

  render() {
    return (
      <Host>
        <div class={`scroll-wrapper ${this.behaviourClasses}`} id={`${SCROLL_ID}${this.compId}`} style={{ '--transition-duration': `${this.transitionDurationSeconds}s` }}>
          <slot name="scroll-affected" />
        </div>
      </Host>
    );
  }
}
